import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

export const reasons = [
  "Décision du patient",
  "Décision du médecin",
  "Inscrit sans consentement",
  "Décès du patient",
  "Changement de centre",
  "Arrêt du programme",
  "Diagnostic en évolution",
  "Fin de traitement",
  "Autre motif"
];
export const proIrcReasons = [
  "Suppléance - hémodialyse avec abord vasculaire défintif (fistule artério-veineuse ou anse)",
  "Suppléance - hémodialyse avec abord vasculaire temporaire (type cathéter) en dehors d’une décompensation aigue",
  "Suppléance - dialyse péritonéale",
  "Suppléance - transplantation",
  "Adressage à une équipe spécialisée soins palliatifs",
  "Perdu de vue"
];

//---- Automatically generated, don't update this part ----

export default class PatientDisenrolledJournalEvent extends JournalEvent {
  static type = "patient-disenrolled-journal-event";

  @attr("string") declare reason: string;

  static validations(intl: IntlService) {
    return {
      reason: validatePresence({
        presence: true,
        description: intl.t(
          "validations.patient-disenrolled-journal-event.reason"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.patient-disenrolled-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "patientDisenrolledJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "patient-disenrolled-journal-event": PatientDisenrolledJournalEvent;
  }
}
